var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "person-card-container" },
    _vm._l(_vm.items, function (person) {
      return _c(
        "div",
        {
          key: person.id,
          staticClass: "person-card-box",
          class: { full: _vm.items.length === 1 },
        },
        [
          _vm.showInitial && person.initial
            ? _c("div", { staticClass: "person-card-avatar" }, [
                _c("div", {
                  staticClass: "person-initial-bg",
                  style: { background: person.color },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "person-initial-text font-light",
                    style: { color: person.color },
                  },
                  [_vm._v(_vm._s(person.initial))]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "person-card-title" }, [
            _c("div", [_vm._v(_vm._s(person.fullName))]),
            _vm._v(" "),
            _c("div", { staticClass: "font-light bold" }, [
              _vm._v(_vm._s(person.otherDetails)),
            ]),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }